<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #TEMP="{ visible, params }">
      <div class="header-title" v-if="visible">
        <h3>{{ params.row && params.row.delivery_name }}</h3>
        <Button
          type="primary"
          @click="exportClick"
          :disabled="disabled()"
          icon="md-arrow-down"
          style="margin-left: 10px"
        >
          {{ $t("export") }}
        </Button>
        <Button
          type="warning"
          @click="addClick(params)"
          icon="md-add"
          style="margin-left: 10px"
          v-if="$hasPermission(385)"
        >
          {{ $t("add") }}
        </Button>
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  getAgentFee,
  getDetails,
  add,
  update,
  del,
  getRules,
  createRules,
  getRulesDetails,
  updateRules,
  delRules
} from "@/api/finance/agent_fee";

import { getCountry } from "@/api/system/country";
import { getAgent } from "@/api/tracker/agent";

import cTable from "@/base/common/index";
export default {
  name: "agentFee",
  components: {
    cTable
  },
  methods: {
    addClick({ row }) {
      this.$refs["table"].getModal("modalAdd").open(null, function() {
        Object.assign(this.$refs["form"].formData, {
          delivery_name: row.delivery_name,
          delivery_id: row.delivery_id,
          to_country: row.to_country,
          id: row.id
        });
      });
    },
    disabled() {
      let modal =
        this.$refs["table"] && this.$refs["table"].getModal("childModal");
      return !(modal && modal.selectAll.length);
    },
    exportClick() {
      let modal = this.$refs["table"].getModal("childModal");
      modal.$page.exportExc({
        data: modal.selectAll,
        fields: modal.table.fields,
        name:
          modal.params.row.delivery_name +
          "-" +
          this.$t("special") +
          this.$t("country_code_validation")
      });
    }
  },
  data() {
    return {
      methods: {
        list: getAgentFee,
        getDetails,
        del,
        add,
        getAgent,
        getCountry,
        update,
        rulesList: getRules,
        createRules,
        getRulesDetails,
        updateRules,
        delRules
      },
      config: {
        height: 630
      },
      modals: {
        childModal: {
          contentSlot: "TEMP",
          config: {
            modalBind: {
              width: "80%"
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                type: "btns",
                width: 150,
                fixed: "right",
                name: () => this.$t("operation"),
                list: [
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "update",
                    bind: {
                      type: "success"
                    },
                    id: 386
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    id: 388
                    // bind: {
                    //   type: "error"
                    // }
                  }
                ],
                methods: {
                  update({ row }) {
                    this.handleRequestMethods("getRulesDetails", row.id).then(
                      res => {
                        this.getModal("modalAdd").type = "update";
                        this.getModal("modalAdd").open(res.payload, () => {
                          this.getModal("modalAdd").setTitle(this.$t("update"));
                        });
                      }
                    );
                  },
                  delete({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods("delRules", row.id).then(
                          res => {
                            this.$Message["success"]({
                              background: true,
                              content: res.msg
                            });
                            this.handleRequestMethods(
                              "rulesList",
                              this.getModal("childModal").params.row.id
                            ).then(res => {
                              this.getModal("childModal").list = res.payload;
                            });
                          }
                        );
                      }
                    });
                  }
                }
              },
              {
                type: "checkbox",
                align: "center",
                width: 60
              },
              {
                name: () => this.$t("target_country"),
                key: "to_country",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: this.$t("collection") + this.$t("mode"),
                key: "collection_method",
                align: "center",
                tooltip: true,
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return value == 1
                      ? this.$t("ratio")
                      : this.$t("fixed") + this.$t("cost_t");
                  }
                }
              },
              // {
              //   name: this.$t("ratio"),
              //   key: "fee_rate",
              //   align: "center",
              //   tooltip: true,
              //   minWidth: 80
              // },
              {
                name: this.$t("fixed") + this.$t("reChAmount"),
                key: "every_amount",
                align: "center",
                tooltip: true,
                minWidth: 80
              },
              {
                name: this.$t("currency_t"),
                key: "every_amount_currency",
                align: "center",
                tooltip: true,
                minWidth: 80
              },
              {
                name:
                  this.$t("interval") +
                  this.$t("lowest") +
                  this.$t("reChAmount"),
                key: "scope_min_cod",
                align: "center",
                tooltip: true,
                minWidth: 110
              },
              {
                name:
                  this.$t("interval") +
                  this.$t("highest") +
                  this.$t("reChAmount"),
                key: "scope_max_cod",
                align: "center",
                tooltip: true,
                minWidth: 110
              },
              {
                name:
                  this.$t("interval") +
                  this.$t("reChAmount") +
                  this.$t("currency_t"),
                key: "scope_currency",
                align: "center",
                tooltip: true,
                minWidth: 110
              },
              // {
              //   name: () => this.$t("createTime"),
              //   key: "create_time",
              //   align: "center",
              //   tooltip: true,
              //   minWidth: 185
              // },
              {
                name: () => this.$t("upTime"),
                key: "update_time",
                align: "center",
                tooltip: true,
                minWidth: 185
              },
              {
                name: () => this.$t("operate"),
                key: "operator_name",
                align: "center",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        modalAdd: {
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: () => true
          },
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = row.id;
              let text =
                this.$page.getModal("modalAdd").type == "update"
                  ? "updateRules"
                  : "createRules";
              this.$page.handleRequestMethods(text, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page
                  .handleRequestMethods(
                    "rulesList",
                    this.$page.getModal("childModal").params.row.id
                  )
                  .then(res => {
                    this.$page.getModal("childModal").list = res.payload;
                  });

                close();
              });
            }
          },

          grid: [
            { to_country: 24 },
            { client_name: 24 },
            { collection_method: 24 },
            { every_amount: 24 },
            { every_amount_currency: 24 },
            { scope_min_cod: 24 },
            { scope_max_cod: 24 },
            { scope_currency: 24 }
          ],
          fields: [
            {
              name: () => this.$t("agentName"),
              key: "delivery_name",
              component: "Input",
              disabled: true
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Input",
              options: [],
              config: { label: "title", value: "code" },
              bind: {
                border: true
              },
              disabled: true,

              placeholder: () => this.$t("select") + this.$t("target_country")
            },
            {
              name: this.$t("collection") + this.$t("type"),
              key: "collection_method",
              component: "Radio",
              options: [
                // { label: this.$t("ratio"), value: 1 },
                { label: this.$t("fixed"), value: 2 }
              ],
              bind: {
                border: true
              },
              default: 2,
              disabled: true
            },

            {
              name: this.$t("fixed") + this.$t("reChAmount"),
              key: "every_amount",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("fixed") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "every_amount_currency",
              component: "Select",
              options: [
                { label: "AED", value: "AED" },
                { label: "CNY", value: "CNY" }
              ],
              default: "AED",
              disabled: true
            },
            {
              name:
                this.$t("interval") + this.$t("numMin") + this.$t("reChAmount"),
              key: "scope_min_cod",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("interval") + this.$t("numMax") + this.$t("reChAmount"),
              key: "scope_max_cod",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name:
                this.$t("interval") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "scope_currency",
              component: "Select",
              options: [
                { label: "AED", value: "AED" },
                { label: "CNY", value: "CNY" }
              ],
              default: "AED",
              disabled: true
            }
          ]
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,

              maskClosable: false
            },
            title: this.$t("handle"),
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              delivery_id: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              is_charge: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              collection_method: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              fee_rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              every_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              every_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              max_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              max_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              vat_rate: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { to_country: 24 },
            { delivery_id: 24 },
            { is_charge: 24 },
            { max_amount: 24 },
            { max_amount_currency: 24 },
            { vat_rate: 24 },
            { remarks: 24 },
            { collection_method: 24 },
            { fee_rate: 24 },
            { every_amount: 24 },
            { every_amount_currency: 24 }
          ],
          fields: [
            {
              name: () => this.$t("agentName"),
              key: "delivery_id",
              component: "Select",
              options: [],
              config: { label: "agent_name", value: "id" },
              bind: {
                border: true
              },
              methods: {
                list({ field }) {
                  this.$nextTick(async () => {
                    field.options = (
                      await this.$page.handleRequestMethods("getAgent")
                    ).payload.rows;
                    field.options.unshift({ agent_name: "ALL", id: 0 });
                  });
                }
              },
              placeholder: () => this.$t("select") + this.$t("clientName")
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              options: [],
              config: { label: "title", value: "code" },
              bind: {
                border: true
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_arrive: 1
                    })
                  ).payload.rows;
                  field.options.unshift({ title: "ALL", code: "*" });
                  this.$forceUpdate();
                }
              },
              placeholder: () => this.$t("select") + this.$t("target_country")
            },
            {
              name: this.$t("whether") + this.$t("charge"),
              key: "is_charge",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            },
            {
              name: this.$t("numMax") + this.$t("reChAmount"),
              key: "max_amount",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 6000,
              show({ formData }) {
                return formData.is_charge == "YES";
              }
            },
            {
              name:
                this.$t("numMax") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "max_amount_currency",
              component: "Select",
              options: [
                { label: "SAR", value: "SAR" },
                { label: "AED", value: "AED" }
              ],
              default: "SAR",
              show({ formData }) {
                return formData.is_charge == "YES";
              }
            },
            {
              name: "Vat" + this.$t("taxFee") + this.$t("ratio"),
              key: "vat_rate",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0.15,
              show({ formData }) {
                return formData.is_charge == "YES";
              }
            },

            {
              name: this.$t("collection") + this.$t("mode"),
              key: "collection_method",
              component: "Radio",
              options: [
                { label: this.$t("ratio"), value: 1 },
                { label: this.$t("fixed") + this.$t("per_ticket"), value: 2 },
                {
                  label:
                    this.$t("special") + this.$t("country_code_validation"),
                  value: 3
                }
              ],
              bind: {
                border: true
              },
              show({ formData }) {
                return formData.is_charge == "YES";
              },
              methods: {
                "on-change"({ formData }) {
                  formData.fee_rate = 0;
                  formData.every_amount = 0;
                  formData.every_amount_currency = "AED";
                  if (formData.is_charge == "NO") {
                    formData.collection_method = "";
                  }
                }
              }
            },
            {
              name: this.$t("ratio"),
              key: "fee_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.001,
                style: "width:100%"
              },
              default: 0,
              show({ formData }) {
                return formData.collection_method == 1;
              }
            },
            {
              name:
                this.$t("per_ticket") +
                this.$t("fixed") +
                this.$t("reChAmount"),
              key: "every_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0,
              show({ formData }) {
                return formData.collection_method == 2;
              }
            },
            {
              name:
                this.$t("per_ticket") +
                this.$t("reChAmount") +
                this.$t("currency_t"),
              key: "every_amount_currency",
              component: "Select",
              options: [
                { label: "AED", value: "AED" },
                { label: "SAR", value: "SAR" }
              ],
              default: "AED",
              show({ formData }) {
                return formData.collection_method == 2;
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 380
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        // {
        //   type: "seq",
        //   name: "序号",
        //   align: "center",
        //   width: 60
        // },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          align: "center"
        },
        {
          name: () => this.$t("agentName"),
          key: "delivery_name",
          align: "center"
        },
        {
          name: this.$t("whether") + this.$t("charge"),
          key: "is_charge",
          align: "center",
          methods: {
            render({ row }) {
              return this.$t(row.is_charge);
            }
          }
        },
        {
          name: this.$t("charge") + this.$t("mode"),
          key: "collection_method",
          align: "center",
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ h, row }) {
              return row.collection_method == 1
                ? this.$t("ratio")
                : row.collection_method == 2
                ? this.$t("fixed") + this.$t("per_ticket")
                : this.$t("special") + this.$t("country_code_validation");
            },
            click({ row }) {
              this.$page.getModal("childModal").open({ row }, function() {
                this.setTitle(
                  this.$t("special") + this.$t("country_code_validation")
                );
                this.$page
                  .handleRequestMethods("rulesList", row.id)
                  .then(res => {
                    this.list = res.payload;
                  });
              });
            }
          },
          disabled({ row }) {
            return !this.$hasPermission(384) || row.collection_method != 3;
          }
        },
        {
          name: this.$t("ratio"),
          key: "fee_rate",
          align: "center"
        },
        {
          name:
            this.$t("per_ticket") + this.$t("fixed") + this.$t("reChAmount"),
          key: "every_amount",
          align: "center"
        },
        {
          name:
            this.$t("per_ticket") +
            this.$t("reChAmount") +
            this.$t("currency_t"),
          key: "every_amount_currency",
          align: "center"
        },
        {
          name: this.$t("highest") + this.$t("reChAmount"),
          key: "max_amount",
          align: "center"
        },
        {
          name: this.$t("reChAmount") + this.$t("currency_t"),
          key: "max_amount_currency",
          align: "center"
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center"
        },
        {
          name: this.$t("operation") + this.$t("time"),
          key: "update_time",
          align: "center",
          width: 170
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 382
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 383
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload, function() {
                  this.config.modalBind.maskClosable = false;
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style>
.header-title {
  display: flex;
  height: 40px;
  align-items: center;
}
</style>
